import { ProviderNames } from "lib/data/models/Providers";
import { getAccountProvider } from "./AdayaUtils";

export const mapCampaignInstances = (campaignData) => {
    let data = campaignData || [];

    // combine campaign instances by campaign name
    data = [...data.reduce((d, o) => {
        const key = o.campaign_name;
        const item = d.get(key) || Object.assign({}, {
            campaign_name: o.campaign_name,
            campaign_id: o.campaign_id
        }, {
            instances: []
        });
        item.instances.push(o);
        return d.set(key, item);
    }, new Map).values()].reverse();

    return data;
}

/**
 * @description Retrieves the Facebook provider's account ID for the given account.
 * @param {*} account
 * @return {*}
 */
 export const getFacebookAccountId = (account) => {
    // find facebook account info:
    if (!account) throw "No account given.";
    let fbAccount = getAccountProvider(account, ProviderNames.FACEBOOK);
    if (!fbAccount) {
        throw "User does not have an active Facebook acount. FacebookDataProvider cannot proceed.";
    }

    // ensure accountId format is act_###
    let accountId = fbAccount.accountId;
    if (accountId.indexOf('act_') < 0) {
        accountId = 'act_' + accountId;
    }
    return accountId;
}